/**
 * File schedule-tour-scripts.js.
 *
 * Handles schedule-tour page events
 *
 */

(function ($) {
  var $calendarPage = $('.calendar-page');
  if (!$calendarPage.length) {
    return;
  }

  $calendarPage.find('.calendar-page__content h2').append(
    '<span class="btn-close-schedule">X</span>'
  );

  $calendarPage.find('.btn-close-schedule').on('click', function () {
    var homeUrl = $calendarPage.attr('data-home-url');
    if (!homeUrl) {
      return;
    }
    document.location.href = homeUrl;
  });
})(jQuery);
